import useGameContext from '~/client/components/Game/context/Game/useGameContext';
import useRewardsNotificationStore from '~/client/components/Game/hooks/useNotificationStore';
import useIsGameCurrencyChangeEnabled from '~/client/hooks/feature/inGameCurrency/useIsGameCurrencyChangeEnabled';
import useIsLoggedIn from '~/client/hooks/user/useIsLoggedIn';
import useSite from '~/client/hooks/useSite';
import isListEmpty from '~/shared/utils/isListEmpty';
import GameCurrencySelect from './GameCurrencySelect';

const InGameCurrency: FC = () => {
  const { isVisible } = useInGameCurrency();
  if (!isVisible) {
    return null;
  }
  return <GameCurrencySelect />;
};

const useInGameCurrency = () => {
  const isGameCurrencyChangeEnabled = useIsGameCurrencyChangeEnabled();
  const isLoggedIn = useIsLoggedIn();
  const { isSbio } = useSite();
  const { inGameCurrencyList } = useGameContext();
  const isInGameCurrencyListEmpty = isListEmpty(inGameCurrencyList);
  const { hasNotification } = useRewardsNotificationStore();
  const isFreebetSwitchNotificationVisible = hasNotification('freeBetReward');
  const isVisible =
    !isSbio &&
    isGameCurrencyChangeEnabled &&
    isLoggedIn &&
    !isInGameCurrencyListEmpty &&
    !isFreebetSwitchNotificationVisible;
  return { isVisible };
};

export default InGameCurrency;
